import * as lc from '../../../../../utils/lodashCustom';

export function restructureCityNameModel(data) {
  return {
    id: lc.get(data, 'id'),
    locale: lc.get(data, 'locale'),
    timeZone: lc.get(data, 'time_zone')
  };
}

export function restructureCountryModel(state, data) {
  return {
    iso_code: lc.get(data, 'country_iso_code'),
    name: lc.get(data, 'country_name')
  };
}

export function restructureRegionModel(state, data) {
  return {
    iso_code: lc.get(data, 'subdivision_1_iso_code'),
    name: lc.get(data, 'subdivision_1_name')
  };
}

export function restructureCityModel(state, data) {
  return {
    iso_code: lc.get(data, 'geoname_id'),
    name: lc.get(data, 'city_name')
  };
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/locale/services/LocaleService/restructuring/index.js